import DataProviderSharePoint from '../dataproviders/DataProvidersSharePoint';

export default class EnmUtils {

    public static getLoginConnectedUser(): string {
        const valueKey = 'value';
        const connectedUserName = document.getElementById('aspConnectedUserName');

        if (connectedUserName != null) {
          const splitedConnectedUserName = connectedUserName[valueKey].split('\\');          
            if (splitedConnectedUserName != null && splitedConnectedUserName[1] != null) {
                return splitedConnectedUserName[1];
            } else {
                return splitedConnectedUserName[0];
            }
        }

        return "";
    }

    public static getDateFrAddOneDay(dateString: string): string {
        if (dateString == null || dateString === "") {
            return '';
        }
        const date: Date = new Date(dateString);
        date.setDate(date.getDate() + 1);
        const month = this.addZero(date.getMonth()+1);
        const day = this.addZero(date.getDate());
        return day + "/" + month + "/" + date.getFullYear();
    }

    public static getDateForCandidatureNumber(dateString: string): string {
        if (dateString == null || dateString === "") {
            return '';
        }
        const date: Date = new Date(dateString);
        const month = this.addZero(date.getMonth()+1);
        const day = this.addZero(date.getDate());
        return day + "-" + month + "-" + date.getFullYear();
    }

    public static addZero(num) {
        return (num >= 0 && num < 10) ? "0" + num : num + "";
    }

    public static promotionIsClosed(stringDateFermeture: string) {
        const dateFermeture = new Date(stringDateFermeture);
        if (dateFermeture != null) {
          dateFermeture.setDate(dateFermeture.getDate() + 1);
          const dateNow = new Date();

          if (dateNow > dateFermeture) {
            return true;
          }
        }
        return false;
    }
    
}
